<template>
  <div class="monitor-list-contanier">
    <div
      :style="{
        left: `${stretchLine.show.left}px`,
        display: stretchLine.show.display
      }"
      class="stretch-line"
    ></div>
    <div class="monitor-list" :class="{ 'hide-right': !layout.showRight }">
      <div class="monitor-list-bar">
        <div class="monitor-list-number">
          <span>已入会参会人({{ onLineNumber }}人)</span>
          <span class="monitor-list-number-sound">
            <svg-icon
              v-if="partyTalkList"
              class="sound-icon"
              icon-class="sound"
            />
            <span :title="partyTalkList">{{ partyTalkList }}</span>
          </span>
        </div>
        <div class="monitor-list-operation">
          <a-button-group>
            <a-button @click="handleMuteMoreEnable">
              <span>静音</span>
            </a-button>
            <a-button @click="handleMuteMoreDisable">
              <span>取消静音</span>
            </a-button>
          </a-button-group>
          <a-button @click="handleCancelOutOnLineChecked" class="button-margin">
            <span>挂断</span>
          </a-button>
          <a-dropdown>
            <a-menu slot="overlay" @click="handleOnLineRoleClick">
              <a-menu-item v-for="item in roleArr" :key="item.id">
                <a-icon type="user" />
                {{ item.name }}
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px">
              修改角色
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
          <a-button @click="handleSaveOnLineContact" class="button-margin">
            <span>保存到通讯录</span>
          </a-button>
        </div>
      </div>
      <div class="monitor-list-content-wrap">
        <div class="monitor-list-content">
          <div class="monitor-row-title" id="online" ref="online">
            <div class="shrink0" style="width:40px">
              <a-checkbox
                :indeterminate="onLineTitleIndeterminate"
                :checked="onLineTitleChecked"
                @change="handleOnlineTitleCheckboxChange"
                class="title-checkbox"
              />
            </div>
            <div style="width:50px" class="shrink0 title-status">
              <span
                class="title-sort"
                @click="handleOnLineOrder(SORT_TYPE_ONLINE_STATUS)"
                >状态</span
              >
            </div>
            <div class="shrink0" style="width:60px">
              <span>角色</span>
            </div>
            <div :style="{ width: `${titleWidth.online.name}px` }">
              <span
                class="title-sort"
                @click="handleOnLineOrder(SORT_TYPE_NAME)"
                >姓名</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.online,
                  stretchLine.type.name.online.name,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div :style="{ width: `${titleWidth.online.phone}px` }">
              <span
                class="title-sort"
                @click="handleOnLineOrder(SORT_TYPE_PHONE)"
                >电话</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.online,
                  stretchLine.type.name.online.phone,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div :style="{ width: `${titleWidth.online.group}px` }">
              <span
                class="title-sort"
                @click="handleOnLineOrder(SORT_TYPE_COMPANY)"
                >组名</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.online,
                  stretchLine.type.name.online.group,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div :style="{ width: `${titleWidth.online.time}px` }">
              <span
                class="title-sort"
                @click="handleOnLineOrder(SORT_TYPE_TIME)"
                >入会时间</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.online,
                  stretchLine.type.name.online.time,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div
              :style="{ width: `${titleWidth.online.department}px` }"
              style="overflow:visible;"
            >
              <span
                class="title-sort"
                @click="handleOnLineOrder(SORT_TYPE_DEPARTMENT)"
                >部门</span
              >
            </div>
          </div>
          <template v-if="onlineList.length === 0">
            <div class="monitor-no-data">
              <svg-icon icon-class="no-data" />
              <span>无数据</span>
            </div>
          </template>
          <template v-else>
            <a-list class="monitor-data-list" @click="handleOnLineClick">
              <VirtualList
                #default="{ items }"
                style="flex: 1; overflow: auto; width: 100%;"
                :items="onlineList"
                :itemSize="38"
              >
                <div v-for="item in items" :key="item.id">
                  <div class="monitor-data-item">
                    <div class="shrink0" style="width:40px">
                      <a-checkbox
                        :checked="onLineCheckBoxList[item.id]"
                        @change="handleOnLineItemCheckBox(item.id, $event)"
                        class="item-checkbox"
                      />
                    </div>
                    <div
                      style="width:50px"
                      class="monitor-data-item-online-status shrink0"
                    >
                      <template
                        v-if="SHOW_STATUS_UN_MUTE === item.onLineStatus"
                      >
                        <span
                          class="monitor-data-item-status"
                          :data-id="item.id"
                          :data-type="CLICK_TYPE_NO_TALK"
                          title="该参会人处于通话状态"
                        >
                          <img
                            :data-id="item.id"
                            :data-type="CLICK_TYPE_NO_TALK"
                            src="@/assets/images/talk.png"
                          />
                        </span>
                      </template>
                      <template
                        v-else-if="SHOW_STATUS_MUTE === item.onLineStatus"
                      >
                        <span
                          class="monitor-data-item-status"
                          :data-id="item.id"
                          :data-type="CLICK_TYPE_TALK"
                          title="该参会人处于静音状态"
                        >
                          <img
                            :data-id="item.id"
                            :data-type="CLICK_TYPE_TALK"
                            src="@/assets/images/no-talk.png"
                          />
                        </span>
                      </template>
                      <template
                        v-else-if="SHOW_STATUS_HOLD === item.onLineStatus"
                      >
                        <span
                          class="monitor-data-item-status"
                          title="该参会人处于等待状态"
                        >
                          <img
                            :data-id="item.id"
                            :data-type="CLICK_TYPE_TALK"
                            src="@/assets/images/waiting.png"
                          />
                        </span>
                      </template>
                      <svg-icon
                        v-if="partyTalkObject[item.id]"
                        class="sound-icon"
                        icon-class="sound"
                      />
                    </div>
                    <div class="shrink0" style="width:60px">
                      <span>{{ roleListObject[item.role] }}</span>
                    </div>
                    <div
                      :style="{ width: `${titleWidth.online.name}px` }"
                      class="monitor-data-item-normal monitor-data-item-name"
                    >
                      <span
                        :data-id="item.id"
                        :data-type="CLICK_TYPE_UPDATE_PARTY_INFO"
                        :title="item.nameAndRole"
                        >{{ item.nameAndRole }}</span
                      >
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.online.phone}px` }"
                    >
                      <span :title="item.nameAndPin">{{
                        encryptTelEnable
                          ? encryptTel(item.showPhone)
                          : item.showPhone
                      }}</span>
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.online.group}px` }"
                    >
                      <span :title="item.company">{{ item.company }}</span>
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.online.time}px` }"
                    >
                      <span :title="item.enterTime">{{ item.enterTime }}</span>
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.online.department}px` }"
                    >
                      <span :title="item.department">{{
                        item.department
                      }}</span>
                    </div>
                  </div>
                </div>
              </VirtualList>
            </a-list>
          </template>
        </div>
      </div>
    </div>
    <div class="monitor-list-middle" @click="handleClickMiddle">
      {{ layout.middleText }}
    </div>
    <div v-if="layout.showRight" class="monitor-list">
      <div class="monitor-list-bar">
        <div class="monitor-list-number">
          <span>未入会参会人({{ offLineNumber }}人)</span>
        </div>
        <div class="monitor-list-operation">
          <a-button-group>
            <a-button @click="handleCallOutChecked">
              <span>外呼</span>
            </a-button>
            <a-button @click="handleCancelOutOffLineChecked">
              <span>取消外呼</span>
            </a-button>
          </a-button-group>
          <a-button @click="handleRemoveOffLineParties" class="button-margin">
            <span>移除</span>
          </a-button>
          <a-dropdown>
            <a-menu slot="overlay" @click="handleOffLineRoleClick">
              <a-menu-item v-for="item in roleArr" :key="item.id">
                <a-icon type="user" />
                {{ item.name }}
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px">
              修改角色
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
          <a-button @click="handleSaveOffLineContact" class="button-margin">
            <span>保存到通讯录</span>
          </a-button>
        </div>
      </div>
      <div class="monitor-list-content-wrap">
        <div class="monitor-list-content">
          <div class="monitor-row-title" id="offline" ref="offline">
            <div class="shrink0" style="width:40px">
              <a-checkbox
                :indeterminate="offLineTitleIndeterminate"
                :checked="offLineTitleChecked"
                @change="handleOfflineTitleCheckboxChange"
                class="title-checkbox"
              />
            </div>
            <div class="shrink0" style="width:50px">
              <span>角色</span>
            </div>
            <div :style="{ width: `${titleWidth.offline.name}px` }">
              <span
                class="title-sort"
                @click="handleOffLineOrder(SORT_TYPE_NAME)"
                >姓名</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.offline,
                  stretchLine.type.name.offline.name,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div :style="{ width: `${titleWidth.offline.phone}px` }">
              <span
                class="title-sort"
                @click="handleOffLineOrder(SORT_TYPE_PHONE)"
                >电话</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.offline,
                  stretchLine.type.name.offline.phone,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div :style="{ width: `${titleWidth.offline.group}px` }">
              <span
                class="title-sort"
                @click="handleOffLineOrder(SORT_TYPE_COMPANY)"
                >组名</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.offline,
                  stretchLine.type.name.offline.group,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div :style="{ width: `${titleWidth.offline.department}px` }">
              <span
                class="title-sort"
                @click="handleOffLineOrder(SORT_TYPE_DEPARTMENT)"
                >部门</span
              >
            </div>
            <div
              class="stretch-bar"
              @mousedown="
                stretchDown(
                  stretchLine.type.status.offline,
                  stretchLine.type.name.offline.department,
                  $event
                )
              "
            >
              <div></div>
            </div>
            <div
              class="title-status"
              :style="{ width: `${titleWidth.offline.status}px` }"
            >
              <span>状态</span>
              <a-dropdown
                v-model="offlineTitleStauts.visible"
                :trigger="['click']"
              >
                <svg-icon
                  @click="e => e.preventDefault()"
                  class="status-icon"
                  icon-class="status"
                />
                <a-menu class="title-status-filter" slot="overlay">
                  <a-menu-item>
                    <a-checkbox
                      :indeterminate="offlineTitleStauts.indeterminate"
                      :checked="offlineTitleStauts.checkAll"
                      @change="handleChangeOfflineTitleStausAll"
                    >
                      全部
                    </a-checkbox>
                  </a-menu-item>
                  <a-menu-item>
                    <a-checkbox
                      :checked="offlineTitleStauts.checkItems.notJoin"
                      @change="
                        handleChangeOfflineTitleStausItem('notJoin', $event)
                      "
                    >
                      未加入
                    </a-checkbox>
                  </a-menu-item>
                  <a-menu-item>
                    <a-checkbox
                      :checked="offlineTitleStauts.checkItems.hangup"
                      @change="
                        handleChangeOfflineTitleStausItem('hangup', $event)
                      "
                    >
                      主动挂断
                    </a-checkbox>
                  </a-menu-item>
                  <a-menu-item>
                    <a-checkbox
                      :checked="offlineTitleStauts.checkItems.noAnswer"
                      @change="
                        handleChangeOfflineTitleStausItem('noAnswer', $event)
                      "
                    >
                      无应答
                    </a-checkbox>
                  </a-menu-item>
                  <a-menu-item>
                    <a-checkbox
                      :checked="offlineTitleStauts.checkItems.chairmanHangup"
                      @change="
                        handleChangeOfflineTitleStausItem(
                          'chairmanHangup',
                          $event
                        )
                      "
                    >
                      主持人挂断
                    </a-checkbox>
                  </a-menu-item>
                  <a-menu-item>
                    <a-checkbox
                      :checked="offlineTitleStauts.checkItems.noConnection"
                      @change="
                        handleChangeOfflineTitleStausItem(
                          'noConnection',
                          $event
                        )
                      "
                    >
                      无法接通
                    </a-checkbox>
                  </a-menu-item>
                  <a-menu-item>
                    <a-checkbox
                      :checked="offlineTitleStauts.checkItems.other"
                      @change="
                        handleChangeOfflineTitleStausItem('other', $event)
                      "
                    >
                      其他
                    </a-checkbox>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
          <template v-if="offlineList.length === 0">
            <div class="monitor-no-data">
              <svg-icon icon-class="no-data" />
              <span>无数据</span>
            </div>
          </template>
          <template v-else>
            <div class="monitor-data-list" @click="handleOffLineClick">
              <VirtualList
                #default="{ items }"
                style="flex: 1; overflow: auto; width: 100%;"
                :items="offlineList"
                :item-size="38"
              >
                <div v-for="item in items" :key="item.id">
                  <div class="monitor-data-item">
                    <div class="shrink0" style="width:40px">
                      <a-checkbox
                        :checked="offLineCheckBoxList[item.uniqueId]"
                        @change="
                          handleOffLineItemCheckBox(item.uniqueId, $event)
                        "
                        class="item-checkbox"
                      />
                    </div>

                    <div class="shrink0" style="width:50px">
                      <span>{{ roleListObject[item.role] }}</span>
                    </div>
                    <div
                      :style="{ width: `${titleWidth.offline.name}px` }"
                      class="monitor-data-item-name monitor-data-item-normal"
                    >
                      <span
                        :data-phone="item.showPhone"
                        :data-type="CLICK_TYPE_UPDATE_PARTY_INFO"
                        class="monitor-data-item-name"
                        :title="item.nameAndRole"
                      >
                        {{ item.nameAndRole }}
                      </span>
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.offline.phone}px` }"
                    >
                      <span :title="item.nameAndPin">{{
                        encryptTelEnable
                          ? encryptTel(item.showPhone)
                          : item.showPhone
                      }}</span>
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.offline.group}px` }"
                    >
                      <span :title="item.company">{{ item.company }}</span>
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.offline.department}px` }"
                    >
                      <span :title="item.department">{{
                        item.department
                      }}</span>
                    </div>
                    <div class="stretch-bar">
                      <div></div>
                    </div>
                    <div
                      class="monitor-data-item-normal"
                      :style="{ width: `${titleWidth.offline.status}px` }"
                    >
                      <span
                        :class="{ 'is-connecting': item.isConnecting }"
                        :data-phone="item.showPhone"
                      >
                        {{ item.statusName }}
                      </span>
                    </div>
                  </div>
                </div>
              </VirtualList>
            </div>
          </template>
        </div>
      </div>
    </div>
    <a-modal
      width="680px"
      v-model="updatePartyInfo.updatePartyInfoModalVisible"
      cancelText="取消"
      okText="确定"
      title="修改参会人信息"
      :maskClosable="false"
      :confirmLoading="updatePartyInfo.confirmLoading"
      @ok="handleUpdatePartyInfo"
    >
      <a-form-model
        ref="updatePartyInfoRuleForm"
        :model="updatePartyInfo.form"
        :rules="updatePartyInfo.rules"
        :label-col="updatePartyInfo.labelCol"
        :wrapper-col="updatePartyInfo.wrapperCol"
      >
        <a-form-model-item ref="name" label="姓名" prop="name">
          <a-input
            v-model.trim="updatePartyInfo.form.name"
            @blur="
              () => {
                $refs.name.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          v-if="custIsOffLine(updatePartyInfo.form.status)"
          label="电话"
          prop="phone"
          ref="phone"
        >
          <a-input-group>
            <a-row :gutter="8">
              <a-col :span="5">
                <a-input
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  v-model.trim="updatePartyInfo.form.countryCode"
                  placeholder="国家码"
                />
              </a-col>
              <a-col :span="5">
                <a-input
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  v-model.trim="updatePartyInfo.form.areaCode"
                  placeholder="区号"
                />
              </a-col>
              <a-col :span="9">
                <a-input
                  v-model.trim="updatePartyInfo.form.phone"
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  @change="
                    () => {
                      $refs.phone.onFieldChange();
                    }
                  "
                  placeholder="座机/手机号"
                />
              </a-col>
              <a-col :span="5">
                <a-input
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  v-model.trim="updatePartyInfo.form.ext"
                  placeholder="分机号"
                />
              </a-col>
            </a-row>
          </a-input-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
// import { RecycleScroller } from "vue-virtual-scroller";
// import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { resizeObserver } from "@/utils/resize";

import { mapState, mapGetters } from "vuex";

import { debounce, throttle } from "lodash";

// import VirtualList from "@/components/virtualList";

import VirtualList from "vue-virtualization-list";

import {
  custOffLine,
  custConnecting,
  custOnLine,
  custMute,
  custIsHold,
  custIsParty,
  CONF_BAIYING_ROLE_LIST,
  disconnectReasonHangup,
  disconnectReasonNoanswer,
  disconnectReasonChairmanHangup,
  disconnectReasonNoconnection,
  disconnectReasonOther,
  disconnectReasonNo
} from "@/model/conf/model";

import {
  callOutOther,
  cancelCallout,
  muteMoreEnable,
  muteMoreDisable,
  removeParties,
  updatePartyInfo,
  partyMuteEnable,
  partyMuteDisable,
  updateRole,
  saveToAddress
} from "@/services/conf";

import {
  validatorName,
  regNumber,
  regTel,
  isChinaCellPhone,
  spliceTelNumberKey
} from "@/utils/validator";

import { delay } from "lodash";

import moment from "moment";

const CLICK_TYPE_UPDATE_PARTY_INFO = "update-party-info";
const CLICK_TYPE_NO_TALK = "no-talk";
const CLICK_TYPE_TALK = "talk";

const SHOW_STATUS_HOLD = 0;
const SHOW_STATUS_MUTE = 1;
const SHOW_STATUS_UN_MUTE = 2;

const SORT_TYPE_NAME = 1;
const SORT_TYPE_PHONE = 2;
const SORT_TYPE_TIME = 3;
const SORT_TYPE_COMPANY = 4;
const SORT_TYPE_DEPARTMENT = 5;
const SORT_TYPE_ONLINE_STATUS = 6;

const titleList = {
  online: ["name", "phone", "group", "time", "department"],
  offline: ["name", "phone", "group", "department", "status"]
};

export default {
  stretchStart: 0,

  pinyinList: {},
  components: {
    VirtualList
  },
  props: {
    meeting: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      CLICK_TYPE_UPDATE_PARTY_INFO,
      CLICK_TYPE_NO_TALK,
      CLICK_TYPE_TALK,
      SORT_TYPE_PHONE,
      SORT_TYPE_NAME,
      SORT_TYPE_TIME,
      SORT_TYPE_COMPANY,
      SORT_TYPE_DEPARTMENT,
      SORT_TYPE_ONLINE_STATUS,
      SHOW_STATUS_HOLD,
      SHOW_STATUS_MUTE,
      SHOW_STATUS_UN_MUTE,
      stretchLine: {
        active: {
          type: null,
          name: null
        },
        show: {
          left: 0,
          display: "none"
        },
        type: {
          status: {
            online: "online",
            offline: "offline"
          },
          name: {
            online: {
              name: "name",
              phone: "phone",
              group: "group",
              time: "time",
              department: "department"
            },
            offline: {
              name: "name",
              phone: "phone",
              group: "group",
              time: "time",
              department: "department"
            }
          }
        }
      },
      titleWidth: {
        online: {
          name: 100,
          phone: 100,
          group: 50,
          time: 90,
          department: 60
        },
        offline: {
          name: 100,
          phone: 100,
          group: 80,
          department: 80,
          status: 60
        }
      },
      sortInfo: {
        online: {
          type: "",
          order: true
        },
        offline: {
          type: "",
          order: true
        }
      },
      layout: {
        showRight: true,
        middleText: ">"
      },
      offLineTitleChecked: false,
      offLineTitleIndeterminate: false,
      checkedOffLineUniqueIdList: [],
      checkedOffLinePhoneList: [], // 未在线已选中的参会人
      onLineTitleChecked: false,
      onLineTitleIndeterminate: false,
      checkedOnLinePhoneList: [], // 在线已选择的参会人
      checkedOnLineIdList: [], // 在线已选择的参会人
      roleArr: [...CONF_BAIYING_ROLE_LIST],
      offlineTitleStauts: {
        visible: false,
        indeterminate: false,
        checkAll: true,
        checkItems: {
          notJoin: true,
          hangup: true,
          noAnswer: true,
          chairmanHangup: true,
          noConnection: true,
          other: true
        }
      },
      updatePartyInfo: {
        updatePartyInfoModalVisible: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
        confirmLoading: false,
        form: {
          company: "",
          partyId: "",
          department: "",
          contactId: "",
          name: "",
          countryCode: "",
          areaCode: "",
          phone: "",
          showPhone: "",
          ext: "",
          role: "",
          participantId: "",
          status: ""
        },
        rules: {
          name: [
            {
              required: true,
              message: "请输入姓名",
              trigger: "blur"
            },
            {
              min: 1,
              max: 50,
              message: "长度1到50个字",
              trigger: "blur"
            },
            {
              validator: this.validatorName,
              trigger: "blur"
            }
          ],
          phone: [
            {
              required: true,
              message: "请输入电话号码",
              trigger: "change"
            },
            {
              required: true,
              message: "请输入电话号码",
              trigger: "blur"
            },
            {
              min: 6,
              max: 16,
              message: "电话/手机长度必须在6~16个字符内",
              trigger: "blur"
            },
            {
              validator: this.validatorPhone,
              trigger: "blur"
            }
          ]
        }
      }
    };
  },
  computed: {
    ...mapState(["listWidth"]),
    ...mapGetters([
      "searchKeyWord",
      "dialoutAllowed",
      "custPhoneList",
      "chairmanRole",
      "chairmanInParty",
      "presenterInParty",
      "meetingQaEnable",
      "onlinePartyListInfo",
      "offlinePartyListInfo",
      "encryptTelEnable"
    ]),
    isOnLineOrder() {
      return "" !== this.sortInfo.online.type;
    },
    isOffLineOrder() {
      return "" !== this.sortInfo.offline.type;
    },
    searchRegExp() {
      let searchRegExp = null;
      if ("" !== this.searchKeyWord) {
        searchRegExp = new RegExp(this.searchKeyWord.replace(/\\/g, "\\\\"));
      }
      return searchRegExp;
    },
    onlineList() {
      const roleIdObj = this.getOnlineRoleIdObj();
      const onLineList = this.getOnLineList(roleIdObj);
      return onLineList;
    },
    offlineList() {
      const roleIdObj = this.getOfflineRoleIdObj();
      const offLineList = this.getOffLineList(roleIdObj);
      return offLineList;
    },
    onlineIdObjectList() {
      const onLineIdObjectList = {};
      this.onlineList.forEach(node => {
        onLineIdObjectList[node.id] = { ...node };
      });
      return onLineIdObjectList;
    },
    offlineShowPhoneObjectList() {
      const offlineShowPhoneObjectList = {};
      this.offlineList.forEach(node => {
        offlineShowPhoneObjectList[node.showPhone] = { ...node };
      });
      return offlineShowPhoneObjectList;
    },
    offlineUniqueIdObjectList() {
      const offlineShowPhoneObjectList = {};
      this.offlineList.forEach(node => {
        offlineShowPhoneObjectList[node.uniqueId] = { ...node };
      });
      return offlineShowPhoneObjectList;
    },
    // onlineShowPhoneList() {
    //   const onlineShowPhoneList = [];
    //   this.list.onLineList.forEach(party => {
    //     onlineShowPhoneList.push(party.showPhone);
    //   });
    //   return onlineShowPhoneList;
    // },
    onlineIdList() {
      const onlineIdList = [];
      this.onlineList.forEach(party => {
        onlineIdList.push(party.id);
      });
      return onlineIdList;
    },
    offLineShowPhoneList() {
      const offLineShowPhoneList = [];
      this.offlineList.forEach(party => {
        offLineShowPhoneList.push(party.showPhone);
      });
      return offLineShowPhoneList;
    },
    offLineUniqueIdList() {
      const offLineUniqueIdList = [];
      this.offlineList.forEach(party => {
        offLineUniqueIdList.push(party.uniqueId);
      });
      return offLineUniqueIdList;
    },
    onLineCheckedList() {
      const onLineCheckedList = [];
      this.checkedOnLineIdList.forEach(id => {
        onLineCheckedList.push(this.onlineIdObjectList[id]);
      });
      return onLineCheckedList;
    },
    offLineCheckedList() {
      const offLineCheckedList = [];
      this.checkedOffLineUniqueIdList.forEach(uniqueId => {
        if (this.offlineUniqueIdObjectList[uniqueId]) {
          offLineCheckedList.push(this.offlineUniqueIdObjectList[uniqueId]);
        }
      });
      return offLineCheckedList;
    },
    onLineCheckBoxList() {
      const onLineCheckBoxList = {};
      this.checkedOnLineIdList.forEach(id => {
        onLineCheckBoxList[id] = true;
      });
      return onLineCheckBoxList;
    },
    offLineCheckBoxList() {
      const offLineCheckBoxList = {};
      this.checkedOffLineUniqueIdList.forEach(uniqueId => {
        offLineCheckBoxList[uniqueId] = true;
      });
      return offLineCheckBoxList;
    },
    onLineCheckedPartyList() {
      let onLineCheckedPartyList = [];
      onLineCheckedPartyList = this.onLineCheckedList.map(party => {
        return {
          partyId: party.id,
          name: party.name,
          role: party.role,
          phone: party.phone,
          participantId: party.participantId,
          countryCode: party.countryCode,
          areaCode: party.areaCode,
          showPhone: party.showPhone,
          contactId: party.contactId
        };
      });
      return onLineCheckedPartyList;
    },
    offLineCheckedPartyList() {
      let offLineCheckedPartyList = [];
      offLineCheckedPartyList = this.offLineCheckedList.map(party => {
        return {
          partyId: party.id,
          name: party.name,
          role: party.role,
          phone: party.phone,
          participantId: party.participantId,
          countryCode: party.countryCode,
          areaCode: party.areaCode,
          showPhone: party.showPhone,
          contactId: party.contactId
        };
      });
      return offLineCheckedPartyList;
    },
    offLineCheckedIdList() {
      let partyIdList = [];
      partyIdList = this.offLineCheckedList.map(party => {
        return {
          partyId: party.id
        };
      });
      return partyIdList;
    },
    onLineCheckedIdList() {
      let partyIdList = [];
      partyIdList = this.onLineCheckedList.map(party => {
        return {
          partyId: party.id
        };
      });
      return partyIdList;
    },
    offLineNumber() {
      return this.offlineList.length;
    },
    onLineNumber() {
      return this.onlineList.length;
    },
    partyTalkList() {
      const partyTalkList = [];
      this.$store.state.partyTalkList.forEach(id => {
        const party = this.$store.getters.partyIdList[id];
        if (party && custOnLine(party.status)) {
          partyTalkList.push(party.name);
        }
      });
      if (partyTalkList.length === 0) {
        return "";
      } else {
        return (
          partyTalkList.slice(0, 3).join(", ") +
          (partyTalkList.length > 3 ? "...等在发言" : "..在发言")
        );
      }
    },
    partyTalkObject() {
      const partyTalkObject = {};
      this.$store.state.partyTalkList.forEach(id => {
        partyTalkObject[id] = true;
      });
      return partyTalkObject;
    },
    roleListObject() {
      const roleListObject = {};
      this.roleArr.forEach(role => {
        roleListObject[role.id] = role.name;
      });
      return roleListObject;
    }
  },
  watch: {
    "listWidth.online": debounce(function(newVal, oldVal) {
      // 防抖
      // 宽度修改
      // console.log(newVal);
      // console.log(oldVal);
      this.resizeStrethch(newVal, oldVal);
    }, 500)
  },
  mounted() {
    resizeObserver(this.$refs.online);
  },
  methods: {
    encryptTel(value) {
      return value.replace(
        this.$constReg.encryptTel.reg,
        this.$constReg.encryptTel.replace
      );
    },
    resizeStrethch(newVal) {
      // 如果尺寸缩小，等比例减小
      const typeList = ["online", "offline"];

      // 计算元素百分比
      typeList.forEach(type => {
        const titleEleLength = titleList[type].length;

        if (newVal < this.listWidth["stash"]) {
          const totalReduceWidth = this.listWidth["stash"] - newVal;
          const titleCount = this.titleCountWidth(type) - 10 * titleEleLength;
          const reduceItemList = [];
          let reduceItemLength = 0;
          for (let i = 0; i < titleEleLength; i++) {
            // // 计算百分比
            const percentage =
              this.titleWidth[type][titleList[type][i]] / titleCount;

            // 如果item - reduceWidth 小于10， 则该item不进行修改，

            const reduceWidth = totalReduceWidth * percentage;
            if (this.titleWidth[type][titleList[type][i]] - reduceWidth > 10) {
              reduceItemList.push(titleList[type][i]);
              reduceItemLength += this.titleWidth[type][titleList[type][i]];
            }
          }

          for (let i = 0; i < reduceItemList.length; i++) {
            const percentage =
              this.titleWidth[type][reduceItemList[i]] / reduceItemLength;
            const reduceWidth = totalReduceWidth * percentage;
            this.titleWidth[type][reduceItemList[i]] -= reduceWidth;
          }
        } else if (newVal > this.listWidth["stash"]) {
          const totalAddWidth = newVal - this.listWidth["stash"];
          const titleCount = this.titleCountWidth(type);
          for (let i = 0; i < titleEleLength; i++) {
            // // 计算百分比
            const percentage =
              this.titleWidth[type][titleList[type][i]] / titleCount;

            const addWidth = totalAddWidth * percentage;

            this.titleWidth[type][titleList[type][i]] += addWidth;
          }
        }
      });
      this.$store.commit("setListWidthStash", newVal);
    },
    stretchDown(type, name, e) {
      this.stretchLine.active.type = type;
      this.stretchLine.active.name = name;
      this.stretchStart = e.clientX;
      document.addEventListener("mouseup", this.stretchUp);
      document.addEventListener("mousemove", this.stretchMove);
    },
    stretchUp(e) {
      const type = this.stretchLine.active.type;
      let newWidth = parseInt(e.clientX - this.stretchStart);

      const notMove = "online" === type ? 215 : 150; // 不可修改宽度元素
      const index = titleList[type].indexOf(this.stretchLine.active.name);

      if (-1 !== index && 0 !== newWidth) {
        if (newWidth > 0) {
          // 如果所有元素总宽度 + 增加的宽度 小于等于外层div总宽度
          const diffWidth =
            this.titleCountWidth(type) +
            notMove +
            newWidth -
            this.listWidth[type];
          if (diffWidth <= 0) {
            // 则只增加该元素宽度
            this.titleWidth[type][this.stretchLine.active.name] += newWidth;
          } else {
            // 则等比例缩减右侧元素宽度，最低10px，如果右侧元素宽度计算后为10，则当前选择的元素宽度为总宽度减左侧元素宽度减右侧元素宽度
            // 获取多余总宽度 diffWidth。如果右侧元素宽度大于diffWidth,右侧元素平均减少diffWidth，选中元素增加newWidth。否则右侧元素减少为最小宽度10px, 选中元素增加右侧元素总长减去默认长度

            // 获取右侧元素长度，
            const titleEleLength = titleList[type].length;
            let rightLength = 0;
            for (let i = index + 1; i < titleEleLength; i++) {
              const width = this.titleWidth[type][titleList[type][i]];
              rightLength += width - 10; // 增加10px最小宽度
            }
            if (rightLength >= diffWidth) {
              // 右侧宽度够
              // 右侧元素平均减少diffWidth
              // 计算右侧元素百分比

              for (let i = index + 1; i < titleEleLength; i++) {
                // 计算百分比
                const eleLength =
                  this.titleWidth[type][titleList[type][i]] - 10; // 减去最小10px
                const percentage = eleLength / rightLength;

                const reduceWidth = diffWidth * percentage;
                this.titleWidth[type][titleList[type][i]] -= parseInt(
                  reduceWidth
                );
              }
              // 选中元素增加newWidth
              this.titleWidth[type][this.stretchLine.active.name] += newWidth;
            } else {
              // 右侧元素长度为默认 10
              for (let i = index + 1; i < titleEleLength; i++) {
                this.titleWidth[type][titleList[type][i]] = 10;
              }
              this.titleWidth[type][this.stretchLine.active.name] +=
                newWidth - diffWidth + rightLength;
              // 选中元素增加 newWidth - diffWidth + righLength - n * 10;
              // newWidth - diffWidth + righLength - n * 10;
            }
          }
        } else {
          // 向左拉
          // 减小当前栏目宽度，多余宽度平均分配到右侧元素

          // 获取当前栏目宽度，最多减少到10px。减少到宽度按比例分配到右侧元素
          const eleWidth = this.titleWidth[type][titleList[type][index]];
          newWidth = -newWidth;
          if (eleWidth - 10 < newWidth) {
            // 如果左移大于元素宽度，则左移长度元素宽度-10
            newWidth = eleWidth - 10;
          }

          this.titleWidth[type][this.stretchLine.active.name] -= newWidth;

          const titleEleLength = titleList[type].length;
          let rightLength = 0;
          for (let i = index + 1; i < titleEleLength; i++) {
            const width = this.titleWidth[type][titleList[type][i]];
            rightLength += width; // 增加10px最小宽度
          }
          for (let i = index + 1; i < titleEleLength; i++) {
            // 计算百分比
            const eleLength = this.titleWidth[type][titleList[type][i]]; // 减去最小10px
            const percentage = eleLength / rightLength;

            const reduceWidth = newWidth * percentage;
            this.titleWidth[type][titleList[type][i]] += parseInt(reduceWidth);
          }
        }
      }

      document.removeEventListener("mouseup", this.stretchUp);
      document.removeEventListener("mousemove", this.stretchMove);
      this.stretchLine.show.display = "none";
    },
    titleCountWidth(type) {
      let count = 0;
      for (const key in this.titleWidth[type]) {
        count += this.titleWidth[type][key];
      }
      return count;
    },
    stretchMove(e) {
      this.stretchLine.show.left = e.pageX;
      this.stretchLine.show.display = "block";
    },
    handleOnLineOrder(type) {
      if (this.sortInfo.online.type === type) {
        this.sortInfo.online.order = !this.sortInfo.online.order;
      } else {
        this.sortInfo.online.type = type;
        this.sortInfo.online.order = true;
      }
    },
    handleOffLineOrder(type) {
      if (this.sortInfo.offline.type === type) {
        this.sortInfo.offline.order = !this.sortInfo.offline.order;
      } else {
        this.sortInfo.offline.type = type;
        this.sortInfo.offline.order = true;
      }
    },
    nameAndRole(name, role) {
      if (custIsParty(role)) {
        return name;
      } else {
        //const roleName = CONF_BAIYING_ROLE_ID_OBJECT[role];
        // return `${name} (${roleName})`;
        return name;
      }
    },
    nameAndPin(showPhone, pin) {
      return showPhone + (pin ? ` [PIN:${pin}]` : "");
    },
    enterTime(connectTime) {
      return connectTime ? moment(connectTime, "x").format("M/DD HH:mm") : "";
    },
    createRoleIdObj() {
      const roleIdObj = {
        onLine: {},
        offLine: {}
      };
      // console.log("-this.roleList--", this.roleList);
      this.roleArr.forEach(role => {
        roleIdObj.onLine[role.id] = [];
        roleIdObj.offLine[role.id] = [];
      });
      return roleIdObj;
    },
    createRoleIdObj2() {
      const roleIdObj = {};
      // console.log("-this.roleList--", this.roleList);
      this.roleArr.forEach(role => {
        roleIdObj[role.id] = [];
      });
      return roleIdObj;
    },
    getOnlineRoleIdObj() {
      const roleIdObj = this.createRoleIdObj2();
      this.onlinePartyListInfo.forEach(node => {
        if (!this.regParty(node)) {
          return;
        }
        if (node && roleIdObj[node?.role]) {
          const party = this.getOnLineListParty(node);
          roleIdObj[party.role].push(party); // 按角色区分
        }
      });
      return roleIdObj;
    },
    getOfflineRoleIdObj() {
      const roleIdObj = this.createRoleIdObj2();
      this.offlinePartyListInfo.forEach(node => {
        if (!this.regParty(node)) {
          return;
        }
        if (node && roleIdObj[node?.role]) {
          if (!this.offlineStatusFilter(node.status, node.disconnectReason)) {
            return;
          }
          const party = this.getOffLineListParty(node);
          roleIdObj[party.role].push(party); // 按角色区分
        }
      });
      return roleIdObj;
    },
    getOnLineList(roleIdObj) {
      const list = [];
      this.roleArr.forEach(role => {
        if (roleIdObj[role.id]) {
          if (this.isOnLineOrder) {
            list.push(...this.onLineOrder(roleIdObj[role.id]));
          } else {
            list.push(...roleIdObj[role.id]);
          }
        }
      });
      return list;
    },
    getOffLineList(roleIdObj) {
      const offLineList = [];
      this.roleArr.forEach(role => {
        if (roleIdObj[role.id]) {
          let partyList = this.orderByKey(
            // 正在连接参会人排在最上面
            roleIdObj[role.id],
            false,
            "isConnecting"
          );
          if (this.isOffLineOrder) {
            offLineList.push(...this.offLineOrder(partyList));
          } else {
            offLineList.push(...partyList);
          }
        }
      });
      return offLineList;
    },
    getOnLineListParty(node) {
      const nameAndRole = this.nameAndRole(node.name, node.role);
      const nameAndPin = this.nameAndPin(node.showPhone, node.pin);
      // node.showPhone + (node.pin ? ` [PIN:${node.pin}]` : "");
      const enterTime = this.enterTime(node.connectTime);
      const onLineStatus = this.onLineStatus(node.status);
      const party = {
        ...node,
        nameAndRole,
        enterTime,
        onLineStatus,
        nameAndPin
      };
      return party;
    },
    getOffLineListParty(node) {
      const nameAndRole = this.nameAndRole(node.name, node.role);
      const nameAndPin = this.nameAndPin(node.showPhone, node.pin);
      // node.showPhone + (node.pin ? ` [PIN:${node.pin}]` : "");
      const onLineStatus = this.onLineStatus(node.status);
      const statusName = this.offLineStatus(node.status, node.disconnectReason);
      const isConnecting = custConnecting(node.status) ? 1 : 0;
      const party = {
        ...node,
        nameAndRole,
        statusName,
        onLineStatus,
        nameAndPin,
        isConnecting
      };
      return party;
    },
    handleClickMiddle() {
      if (this.layout.showRight) {
        this.layout.showRight = false;
        this.layout.middleText = "<";
      } else {
        this.layout.showRight = true;
        this.layout.middleText = ">";
      }
    },
    handleOnlineTitleCheckboxChange(e) {
      this.onLineTitleChecked = e.target.checked;
      this.onLineTitleIndeterminate = false;
      if (e.target.checked) {
        this.checkedOnLineIdList.splice(
          0,
          this.checkedOnLineIdList.length,
          ...this.onlineIdList
        );
      } else {
        this.checkedOnLineIdList.splice(0, this.checkedOnLineIdList.length);
      }
    },
    handleOfflineTitleCheckboxChange(e) {
      this.offLineTitleChecked = e.target.checked;
      this.offLineTitleIndeterminate = false;
      if (e.target.checked) {
        this.checkedOffLineUniqueIdList.splice(
          0,
          this.checkedOffLineUniqueIdList.length,
          ...this.offLineUniqueIdList
        );
      } else {
        this.checkedOffLineUniqueIdList.splice(
          0,
          this.checkedOffLineUniqueIdList.length
        );
      }
    },
    handleOnLineItemCheckBox(id, e) {
      if (e) {
        e.preventDefault();
      }
      if (e.target.checked) {
        // this.checkedOnLinePhoneList.push(phone);
        this.checkedOnLineIdList.push(id);
        if (this.onlineIdList.length === this.checkedOnLineIdList.length) {
          this.onLineTitleChecked = true;
          this.onLineTitleIndeterminate = false;
        } else {
          this.onLineTitleIndeterminate = true;
        }
      } else {
        this.onLineTitleChecked = false;

        // const index = this.checkedOnLinePhoneList.indexOf(phone);
        const index = this.checkedOnLineIdList.indexOf(id);
        if (-1 !== index) {
          // this.checkedOnLinePhoneList.splice(index, 1);
          this.checkedOnLineIdList.splice(index, 1);
        }
        if (0 === this.checkedOnLineIdList.length) {
          this.onLineTitleIndeterminate = false;
        } else {
          this.onLineTitleIndeterminate = true;
        }
      }
    },
    handleOffLineItemCheckBox(uniqueId, e) {
      if (e) {
        e.preventDefault();
      }
      if (e.target.checked) {
        // this.checkedOffLinePhoneList.push(phone);
        this.checkedOffLineUniqueIdList.push(uniqueId);
        if (
          this.offLineUniqueIdList.length ===
          this.checkedOffLineUniqueIdList.length
        ) {
          this.offLineTitleChecked = true;
          this.offLineTitleIndeterminate = false;
        } else {
          this.offLineTitleIndeterminate = true;
        }
      } else {
        this.offLineTitleChecked = false;
        const index = this.checkedOffLineUniqueIdList.indexOf(uniqueId);

        if (-1 !== index) {
          this.checkedOffLineUniqueIdList.splice(index, 1);
        }

        if (0 === this.checkedOffLineUniqueIdList.length) {
          this.offLineTitleIndeterminate = false;
        } else {
          this.offLineTitleIndeterminate = true;
        }
      }
    },
    uncheckedOffLineWaring() {
      if (this.checkedOffLineUniqueIdList.length === 0) {
        this.$info({
          title: "提示",
          content: "当前未选中任何参会人，请选择后重试"
        });
        return false;
      } else {
        return true;
      }
    },
    uncheckedOnLineWaring() {
      if (this.checkedOnLineIdList.length === 0) {
        this.$info({
          title: "提示",
          content: "当前未选中任何参会人，请选择后重试"
        });
        return false;
      } else {
        return true;
      }
    },
    clearOffLineChecked() {
      this.checkedOffLineUniqueIdList.splice(
        0,
        this.checkedOffLineUniqueIdList.length
      );
      this.offLineTitleChecked = false;
      this.offLineTitleIndeterminate = false;
    },
    clearOnLineChecked() {
      this.checkedOnLineIdList.splice(0, this.checkedOnLineIdList.length);
      this.onLineTitleChecked = false;
      this.onLineTitleIndeterminate = false;
    },
    handleCallOutChecked: throttle(
      function() {
        if (!this.dialoutAllowed) {
          // 提示没有外呼权限
          this.$info({
            title: "提示",
            // JSX support
            content: "您没有外呼权限"
          });
        } else {
          if (this.uncheckedOffLineWaring()) {
            const partyList = [];
            this.offLineCheckedList.forEach(party => {
              partyList.push({
                name: party.name,
                role: party.role,
                phone: party.phone,
                countryCode: party.countryCode,
                areaCode: party.areaCode,
                pin: party.pin,
                company: party.company,
                department: party.department,
                participantId: party.participantId
              });
            });
            if (partyList.length > 0) {
              callOutOther(this.meeting.bridgeName, partyList)
                .then(() => {
                  // 对应电话显示正在连接中
                  // 发送更新ws数据，正在呼叫中
                  // const callOutPartyList = [];
                  // this.offLineCheckedList.forEach(party => {
                  //   callOutPartyList.push({
                  //     showPhone: party.showPhone,
                  //     status: 2, // 正在连接
                  //     disconnectReason: 0
                  //   });
                  // });

                  // this.$eventHub.$emit("call-out-party", callOutPartyList);
                  this.clearOffLineChecked();
                  this.$message.success(`正在外呼中...`);
                })
                .catch(error => {
                  this.$message.error(`外呼失败，请稍后再试`);
                  console.log(error);
                });
            }
          }
        }
      },
      1000,
      { trailing: false }
    ),
    handleCancelOutOnLineChecked: throttle(
      function() {
        if (this.uncheckedOnLineWaring()) {
          cancelCallout(this.meeting.bridgeName, this.onLineCheckedIdList)
            .then(() => {
              this.$message.success(`正在挂断中...`);
              this.clearOnLineChecked();
            })
            .catch(error => {
              console.log(error);
            });
        }
      },
      1000,
      { trailing: false }
    ),
    handleCancelOutOffLineChecked: throttle(
      function() {
        if (this.uncheckedOffLineWaring()) {
          cancelCallout(this.meeting.bridgeName, this.offLineCheckedIdList)
            .then(() => {
              this.$message.success(`正在取消外呼中...`);
              this.clearOffLineChecked();
            })
            .catch(error => {
              console.log(error);
            });
        }
      },
      1000,
      { trailing: false }
    ),
    handleRemoveOffLineParties: throttle(
      function() {
        if (this.uncheckedOffLineWaring()) {
          removeParties(this.meeting.bridgeName, this.offLineCheckedPartyList)
            .then(() => {
              // 成功后将参会人加入移除列表
              // 移除参与人
              this.$message.success(`正在移除中...`);
              this.clearOffLineChecked();
            })
            .catch(error => {
              this.$message.error(`移除失败，请稍后再试`);
              console.log(error);
            });
        }
      },
      1000,
      { trailing: false }
    ),
    handleOnLineRoleClick: throttle(
      function(e) {
        const role = e.key;
        if (this.uncheckedOnLineWaring()) {
          if (!this.meetingQaEnable) {
            updateRole(role, this.onLineCheckedPartyList)
              .then(() => {
                this.$message.success(`正在修改角色中...`);
                this.clearOnLineChecked();
              })
              .catch(err => {
                this.$message.error(`修改角色失败，请稍后再试`);
                console.log(err);
              });
          } else {
            this.$message.warn(`问答已开启，暂不可以修改角色`);
          }
        }
        // 获取更新的
      },
      1000,
      { trailing: false }
    ),
    handleOffLineRoleClick: throttle(
      function(e) {
        const role = e.key;
        if (this.uncheckedOffLineWaring()) {
          if (!this.meetingQaEnable) {
            updateRole(role, this.offLineCheckedPartyList)
              .then(() => {
                this.$message.success(`正在修改角色中...`);
                this.clearOffLineChecked();
              })
              .catch(err => {
                this.$message.error(`修改角色失败，请稍后再试`);
                console.log(err);
              });
          } else {
            this.$message.warn(`问答已开启，暂不可以修改角色`);
          }
        }
        // 获取更新的
      },
      1000,
      { trailing: false }
    ),
    handleSaveOnLineContact: throttle(
      function() {
        if (this.uncheckedOnLineWaring()) {
          // 判断contactId
          const savePartyList = [];
          this.onLineCheckedPartyList.forEach(party => {
            if (party.contactId === 0) {
              savePartyList.push(party);
            }
          });
          if (savePartyList.length > 0) {
            saveToAddress(savePartyList)
              .then(() => {
                this.$message.success("保存成功");
                this.clearOnLineChecked();
              })
              .catch(err => {
                this.$message.error("保存失败");
                console.log(err);
              });
          } else {
            this.$message.info("选中的参会人都已存在于通讯录");
          }
        }
      },
      1000,
      { trailing: false }
    ),
    handleSaveOffLineContact: throttle(
      function() {
        if (this.uncheckedOffLineWaring()) {
          // 判断contactId
          const savePartyList = [];
          this.offLineCheckedPartyList.forEach(party => {
            if (party.contactId === 0) {
              savePartyList.push(party);
            }
          });
          if (savePartyList.length > 0) {
            saveToAddress(savePartyList)
              .then(() => {
                this.$message.success("保存成功");
                this.clearOffLineChecked();
              })
              .catch(err => {
                this.$message.error("保存失败");
                console.log(err);
              });
          } else {
            this.$message.info("选中的参会人都已存在于通讯录");
          }
        }
      },
      1000,
      { trailing: false }
    ),
    handleOnLineClick: (function() {
      const clickTypeList = {
        [CLICK_TYPE_UPDATE_PARTY_INFO]: "clickUpdatePartyInfo",
        [CLICK_TYPE_NO_TALK]: "clickNoTalk",
        [CLICK_TYPE_TALK]: "clickTalk"
      };

      return function(e) {
        if (e && e.target && e.target.dataset) {
          const id = e.target.dataset.id;
          const type = e.target.dataset.type;
          if (type && id) {
            const node = this.onlineIdObjectList[id];
            const cb = clickTypeList[type];
            if (cb) {
              this[cb](node);
            }
          }
        }
      };
    })(),
    clickNoTalk(node) {
      const key = this.buildThrottleKey(
        node.countryCode,
        node.areaCode,
        node.phone
      );
      if (this.throttle(key)) {
        partyMuteEnable(node.id)
          .then(() => {})
          .catch(error => {
            console.log(error);
            this.$message.error(`静音${node.name}请求失败。`);
          });
      }
    },
    clickTalk(node) {
      const key = this.buildThrottleKey(
        node.countryCode,
        node.areaCode,
        node.phone
      );
      if (this.throttle(key)) {
        partyMuteDisable(node.id)
          .then(() => {})
          .catch(error => {
            console.log(error);
            this.$message.error(`取消静音${node.name}请求失败。`);
          });
      }
    },
    handleOffLineClick(e) {
      if (e && e.target && e.target.dataset) {
        const phone = e.target.dataset.phone;
        const type = e.target.dataset.type;
        if (type && phone) {
          const node = this.offlineShowPhoneObjectList[phone];
          switch (type) {
            case CLICK_TYPE_UPDATE_PARTY_INFO:
              this.clickUpdatePartyInfo(node);
              break;
          }
        }
      }
    },
    handleUpdatePartyInfo() {
      this.$refs.updatePartyInfoRuleForm.validate(valid => {
        if (valid) {
          const phone =
            this.updatePartyInfo.form.phone +
            ("" !== this.updatePartyInfo.form.ext
              ? "-" + this.updatePartyInfo.form.ext
              : "");
          let param = {
            phone,
            partyId: this.updatePartyInfo.form.partyId ?? "",
            name: this.updatePartyInfo.form.name,
            countryCode: this.updatePartyInfo.form.countryCode,
            areaCode: this.updatePartyInfo.form.areaCode,
            role: this.updatePartyInfo.form.role,
            contactId: this.updatePartyInfo.form.contactId,
            participantId: this.updatePartyInfo.form.participantId,
            showPhone: this.updatePartyInfo.form.showPhone
          };
          this.updatePartyInfo.confirmLoading = true;
          updatePartyInfo(param)
            .then(() => {
              this.updatePartyInfo.confirmLoading = false;
              this.updatePartyInfo.updatePartyInfoModalVisible = false;
            })
            .catch(err => {
              this.updatePartyInfo.confirmLoading = false;
              this.$message.error("修改信息失败。");
              console.log(err);
            });
        }
      });
    },
    handleMuteMoreEnable: throttle(
      function() {
        if (!this.chairmanInParty && !this.presenterInParty) {
          this.$info({
            title: "提示",
            content: "当前会议中没有主持人或主讲人，该功能不可用"
          });
        } else {
          if (this.uncheckedOnLineWaring()) {
            muteMoreEnable(this.onLineCheckedIdList)
              .then(() => {
                this.$message.success(`静音中...`);
                this.clearOnLineChecked();
              })
              .catch(error => {
                this.$message.error(`静音失败，请稍后再试`);
                console.log(error);
              });
          }
        }
      },
      1000,
      { trailing: false }
    ),
    handleMuteMoreDisable: throttle(
      function() {
        if (!this.chairmanInParty && !this.presenterInParty) {
          this.$info({
            title: "提示",
            content: "当前会议中没有主持人或主讲人，该功能不可用"
          });
        } else {
          if (this.uncheckedOnLineWaring()) {
            muteMoreDisable(this.onLineCheckedIdList)
              .then(() => {
                this.$message.success(`取消静音中...`);
                this.clearOnLineChecked();
              })
              .catch(error => {
                this.$message.error(`取消静音失败，请稍后再试`);
                console.log(error);
              });
          }
        }
      },
      1000,
      { trailing: false }
    ),
    clickUpdatePartyInfo(node) {
      console.log(node);
      this.updatePartyInfo.form.status = node.status;
      this.updatePartyInfo.form.contactId = node.contactId;
      this.updatePartyInfo.form.phone = node.phone;
      this.updatePartyInfo.form.participantId = node.participantId;
      this.updatePartyInfo.form.name = node.name;
      this.updatePartyInfo.form.company = node.company;
      this.updatePartyInfo.form.countryCode = node.countryCode;
      this.updatePartyInfo.form.areaCode = node.areaCode;
      this.updatePartyInfo.form.role = node.role;
      this.updatePartyInfo.form.showPhone = node.showPhone;
      this.updatePartyInfo.form.partyId = node.id;

      const regAreaCode = new RegExp("^0?" + node.areaCode);
      // console.log(regAreaCode.test(node.phone));
      const phoneAndExt = node.phone.replace(regAreaCode, "");
      // console.log(phoneAndExt);
      let phone, ext;
      [phone, ext] = phoneAndExt.split("-");
      // console.log(phone, ext);
      this.updatePartyInfo.form.phone = phone;
      this.updatePartyInfo.form.ext = ext || "";

      this.updatePartyInfo.updatePartyInfoModalVisible = true;
      // this.$refs.updatePartyInfoRuleForm.validate();
      this.$nextTick(() => {
        this.$refs.updatePartyInfoRuleForm.validate();
      });
    },
    validatorName(rule, value, callback) {
      if (!validatorName(value)) {
        callback(new Error("姓名格式有勿，请勿输入特殊字符~`'\\/|#¥￥$%^&。"));
      } else {
        callback();
      }
    },
    validatorCustPhone(phone) {
      const party = this.custPhoneList[phone];
      // 验证是否有重复电话，并且重复电话不是当前编辑人的电话
      return !!(
        party && party.contactId !== this.updatePartyInfo.form.contactId
      );
    },
    regUpdatePartyInfo() {
      return (
        regNumber(this.updatePartyInfo.form.countryCode) &&
        regNumber(this.updatePartyInfo.form.areaCode) &&
        regNumber(this.updatePartyInfo.form.phone) &&
        regNumber(this.updatePartyInfo.form.ext)
      );
    },
    validatorPhone(rule, value, callback) {
      if (this.regUpdatePartyInfo()) {
        const countryCode = this.updatePartyInfo.form.countryCode || "86";
        const splicePhone = spliceTelNumberKey(
          countryCode,
          this.updatePartyInfo.form.areaCode,
          this.updatePartyInfo.form.phone,
          this.updatePartyInfo.form.ext
        );
        if (!this.validatorCustPhone(splicePhone)) {
          if (!isChinaCellPhone(countryCode, this.updatePartyInfo.form.phone)) {
            if (!regTel(this.updatePartyInfo.form.phone)) {
              callback(new Error("电话号码格式不正确，第一位不能为0"));
            } else if ("" === this.updatePartyInfo.form.areaCode) {
              callback(new Error("请输入区号"));
            }
          }
        } else {
          // 验证号码是否跟已参会人重复
          callback(new Error("电话号码不能跟已参会人员相同。"));
        }
      } else {
        callback(new Error("只能输入数字"));
      }
      callback();
    },
    custIsChairman(role) {
      return role === this.chairmanRole;
    },
    custIsOffLine(status) {
      return custOffLine(status);
    },
    onLineStatus(status) {
      // disconnectReason 不为0显示断开原因，否则显示status
      if (custMute(status)) {
        return SHOW_STATUS_MUTE;
      } else if (custIsHold(status)) {
        return SHOW_STATUS_HOLD;
      } else {
        return SHOW_STATUS_UN_MUTE;
      }
    },
    getDisconnectReasonName(disconnectReason) {
      const list = {
        2: "主动挂断",
        3: "无应答",
        1: "主持人挂断",
        4: "无法接通"
      };
      return list[disconnectReason] || "其它";
    },
    offLineStatus(status, disconnectReason) {
      if (0 === disconnectReason) {
        if (custConnecting(status)) {
          return "正在连接";
        } else {
          return "未加入";
        }
      } else {
        return this.getDisconnectReasonName(disconnectReason);
      }
    },
    offLineOrder: (function() {
      const sortTypeList = {
        [SORT_TYPE_NAME]: "nameLetters",
        [SORT_TYPE_PHONE]: "showPhone",
        [SORT_TYPE_TIME]: "connectTime",
        [SORT_TYPE_COMPANY]: "companyLetters",
        [SORT_TYPE_DEPARTMENT]: "departmentLetters"
      };

      return function(partyList) {
        const sortType = sortTypeList[this.sortInfo.offline.type];
        if (sortType) {
          return this.offLineOrderByKey(partyList, sortType);
        }
        return partyList;
      };
    })(),
    onLineOrder: (function() {
      const sortTypeList = {
        [SORT_TYPE_NAME]: "nameLetters",
        [SORT_TYPE_PHONE]: "showPhone",
        [SORT_TYPE_TIME]: "connectTime",
        [SORT_TYPE_COMPANY]: "companyLetters",
        [SORT_TYPE_DEPARTMENT]: "departmentLetters",
        [SORT_TYPE_ONLINE_STATUS]: "onLineStatus"
      };
      return function(partyList) {
        const sortType = sortTypeList[this.sortInfo.online.type];
        if (sortType) {
          return this.onLineOrderByKey(partyList, sortType);
        }
        return partyList;
      };
    })(),
    onLineOrderByKey(partyList, key) {
      // 呼叫 挂断 静音 取消静音的 节流功能
      return this.orderByKey(partyList, this.sortInfo.online.order, key);
    },
    offLineOrderByKey(partyList, key) {
      // 呼叫 挂断 静音 取消静音的 节流功能
      return this.orderByKey(partyList, this.sortInfo.offline.order, key);
    },
    orderByKey(partyList, order, key) {
      return partyList.sort(function(a, b) {
        if (a[key] === b[key]) {
          return 0;
        } else {
          if (a[key] > b[key]) {
            return order ? 1 : -1;
          } else {
            return order ? -1 : 1;
          }
        }
      });
    },
    buildThrottleKey(countryCode, areaCode, phone) {
      return `${countryCode}-${areaCode}-${phone}`;
    },
    handleChangeOfflineTitleStausAll(e) {
      // this.offlineTitleStauts.checkItems
      this.offlineTitleStauts.checkAll = e.target.checked;
      this.offlineTitleStauts.indeterminate = false;
      for (let key in this.offlineTitleStauts.checkItems) {
        this.offlineTitleStauts.checkItems[key] = e.target.checked;
      }
    },
    handleChangeOfflineTitleStausItem(item, e) {
      // this.offlineTitleStauts.checkAll = e.target.checked;
      this.offlineTitleStauts.checkItems[item] = e.target.checked;
      let checkAll = true;
      let checkNum = 0;
      for (let key in this.offlineTitleStauts.checkItems) {
        if (this.offlineTitleStauts.checkItems[key]) {
          checkNum++;
        } else {
          checkAll = false;
        }
        this.offlineTitleStauts.checkAll = checkAll;
        this.offlineTitleStauts.indeterminate = !checkAll && checkNum > 0;
      }
    },
    offlineStatusFilter(status, disconnectReason) {
      if (this.offlineTitleStauts.checkAll) {
        return true;
      } else if (custConnecting(status)) {
        return true;
      } else {
        return this.disconnectReasonFilter(disconnectReason);
      }
    },
    disconnectReasonFilter: (function() {
      const funcList = {
        hangup: disconnectReasonHangup,
        noAnswer: disconnectReasonNoanswer,
        chairmanHangup: disconnectReasonChairmanHangup,
        noConnection: disconnectReasonNoconnection,
        other: disconnectReasonOther,
        notJoin: disconnectReasonNo
      };
      return function(disconnectReason) {
        let flag = false;
        for (let key in this.offlineTitleStauts.checkItems) {
          if (
            this.offlineTitleStauts.checkItems[key] &&
            funcList[key](disconnectReason)
          ) {
            flag = true;
            break;
          }
        }

        return flag;
      };
    })(),
    throttle: (() => {
      // 呼叫 挂断 静音 取消静音的 节流功能
      const operationObj = {};
      return function(key, time = 1000) {
        if (operationObj[key]) {
          return false;
        }
        operationObj[key] = true;
        delay(() => {
          operationObj[key] = false;
        }, time);
        return true;
      };
    })(),
    regParty(party) {
      if (
        this.searchRegExp &&
        !this.searchRegExp.test(party.name) &&
        !this.searchRegExp.test(party.phone) &&
        !this.searchRegExp.test(party.nameLetters)
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less">
.monitor-list-contanier {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;

  .stretch-line {
    position: absolute;
    height: 100%;
    width: 2px;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
    height: calc(100% - 116px);
    top: 112px;
  }

  .monitor-list {
    width: calc(50% - 20px);
    background: #fff;
    height: calc(100% - 10px);
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    display: flex;
    overflow: visible;
    flex-direction: column;

    .sound-icon {
      width: 10px !important;
      height: 12px !important;
    }

    .monitor-list-bar {
      margin-top: 20px;
      padding-left: 20px;
      height: 76px;

      .monitor-list-number {
        display: flex;
        flex: 1;
        overflow: hidden;

        & :first-child {
          font-size: 16px;
          letter-spacing: -0.18px;
          color: #333333;
          margin-right: 10px;
        }

        & :nth-child(2) {
          opacity: 0.7;
          font-size: 12px;
          color: #000000;
        }

        .monitor-list-number-sound {
          display: flex;
          flex: 1;
          overflow: hidden;
          align-items: center;

          span {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }

      .monitor-list-operation {
        margin-top: 20px;
        display: flex;
        align-items: center;

        .button-margin {
          margin-left: 10px;
        }

        .button-right-radius0 {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        .button-left-radius0 {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

        button {
          background: #fff;
          border: solid 1px #e5e5e5;
          // border-radius: 0;
          font-size: 13px;
          height: 32px;
          color: #333333;

          &:focus {
            outline: none;
            color: #333333;
            border-color: #e5e5e5;
          }

          &:after {
            border: 0 none;
            opacity: 0;
            animation: none 0 ease 0 1 normal;
          }

          &:hover {
            outline: none;
            border: solid 1px rgba(0, 0, 0, 0.4);
            background-color: rgba(255, 255, 255, 0.8);
            color: #333333;
          }

          &:active {
            color: #333333;
            border: solid 1px rgba(0, 0, 0, 0.4);
            background-color: rgba(0, 0, 0, 0.3);
          }

          &:disabled {
            border-color: #d9d9d9 !important;
            color: rgba(0, 0, 0, 0.25) !important;
            background-color: #f5f5f5 !important;
            text-shadow: none !important;
            box-shadow: none !important;
          }
        }
      }
    }

    .monitor-list-content-wrap {
      display: flex;
      flex: 1;
      overflow: auto;
      margin-top: 10px;
      padding: 0 10px;

      .monitor-list-content {
        flex: 1;
        display: flex;
        overflow: auto;
        flex-direction: column;

        .ant-list-item {
          padding: 0;

          & :hover {
            background-color: #f6f8ff;
          }
        }
      }

      .monitor-row-normal() {
        font-size: 13px;
        color: #333333;
        align-items: center;
        border-bottom: 1px solid #e3e7ed;
        text-align: left;

        .title-checkbox {
          margin-left: 10px;
          vertical-align: -2px;
        }
      }

      .stretch-bar-normal() {
        width: 10px;
        min-width: 10px;
        background-color: rgba(255, 255, 255, 0);
        height: 100%;
        flex-shrink: 0;

        > div {
          margin: 0 auto;
          height: 100%;
          width: 1px;
          background-color: rgba(0, 0, 0, 0.1);
        }
      }

      .monitor-row-title {
        .monitor-row-normal();
        display: flex;
        white-space: nowrap;
        overflow: hidden;

        > div {
          // flex-shrink: 0;
          overflow: hidden;
          min-width: 10px;
          user-select: none;
        }

        .stretch-bar {
          .stretch-bar-normal();
          cursor: col-resize;
          //
        }

        .ant-col {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .title-sort {
          cursor: pointer;
        }

        .title-status {
          position: relative;
          overflow: visible;

          .status-icon {
            margin-left: 2px;
            vertical-align: middle;
            cursor: pointer;

            &:focus {
              outline: 0;
            }
          }
        }

        height: 38px;
        border-top: 1px solid #e3e7ed;
        background-color: #f4f4f4;
      }

      .monitor-no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex: 1;

        svg {
          width: 160px;
          height: 120px;
        }

        span {
          color: rgba(0, 0, 0, 0.5);
        }
      }

      .monitor-data-list {
        flex: 1;
        display: flex;
        overflow: auto;

        .ant-spin-nested-loading {
          flex: 1;
          display: flex;
          overflow: auto;

          .ant-spin-container {
            flex: 1;
            display: flex;
            overflow: auto;
          }
        }

        .monitor-data-item {
          .monitor-row-normal();
          display: flex;
          width: 100%;
          height: 38px;

          > div {
            // flex-shrink: 0;
            overflow: hidden;
            min-width: 10px;
          }

          .operation-icon {
            width: 24px;
            height: 24px;
          }

          .stretch-bar {
            .stretch-bar-normal();
            //
          }

          .ant-col {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .item-checkbox {
            margin-left: 10px;
            vertical-align: -2px;
          }

          .monitor-data-item-online-status {
            display: flex;
            align-items: center;
            justify-content: space-between;

            svg {
              margin-right: 8px;
            }
          }

          .monitor-data-item-normal {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .monitor-data-item-name {
            // display: flex;
            // align-items: center;

            cursor: pointer;
          }

          .monitor-data-item-status {
            cursor: pointer;

            img {
              width: 24px;
              height: 24px;
            }
          }

          .is-connecting {
            color: #4f8bff;
          }
        }
      }
    }
  }

  .hide-right {
    width: calc(100% - 20px);
  }

  .monitor-list-middle {
    background: #fff;
    width: 10px;
    height: 80px;
    border-radius: 2px;
    border: solid 1px #d8d8d8;
    line-height: 80px;
    color: rgba(0, 0, 0, 0.3);
    font-size: 8px;
    cursor: pointer;

    &:hover {
      color: #4f8bff;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      border: solid 1px #4f8bff;
    }
  }
}

.title-status-filter {
  .ant-dropdown-menu-item {
    label {
      width: 100%;
    }
  }
}
</style>
